{
    "name": "AppState",
    "schemas": "@wix/dm-fragment-schemas/appState",
    "defaultConfigurations": {
        "singletonInstance": "AppStateSingleton"
    }
}
